import { render, staticRenderFns } from "./CustomBrokerage.vue?vue&type=template&id=93589f40&scoped=true"
import script from "./CustomBrokerage.vue?vue&type=script&lang=js"
export * from "./CustomBrokerage.vue?vue&type=script&lang=js"
import style0 from "./CustomBrokerage.vue?vue&type=style&index=0&id=93589f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93589f40",
  null
  
)

export default component.exports